/** Action types of `importWizardReducer`. Later stories of the wizard only append here. */
export const IMPORT_ACTIONS = Object.freeze({
  FILE_LOADED: 'FILE_LOADED',
  FILE_REPLACED: 'FILE_REPLACED',
  SET_STEP: 'SET_STEP',
  SET_MAPPING: 'SET_MAPPING',
  BUILD_ROWS: 'BUILD_ROWS',
  SET_ROW_ACCESS: 'SET_ROW_ACCESS',
  APPLY_ACCESS_FROM_FILE: 'APPLY_ACCESS_FROM_FILE',
  RESTORE_ROW_ACCESS: 'RESTORE_ROW_ACCESS',
  RESTORE_ROWS: 'RESTORE_ROWS',
  FIX_ROW: 'FIX_ROW',
  REMOVE_ROWS: 'REMOVE_ROWS',
  SET_REVIEW_SEARCH: 'SET_REVIEW_SEARCH',
  SET_REVIEW_FILTERS: 'SET_REVIEW_FILTERS',
  SET_REVIEW_SELECTION: 'SET_REVIEW_SELECTION',
  RESOLVE_DUPLICATE: 'RESOLVE_DUPLICATE',
  RESOLVE_ADMIN: 'RESOLVE_ADMIN',
  RESOLVE_OUTSIDE_DOMAIN: 'RESOLVE_OUTSIDE_DOMAIN',
  SET_INVITE: 'SET_INVITE',
  RESET: 'RESET',
});
